import { render } from "./BrandBar.vue?vue&type=template&id=8ccd0140"
import script from "./BrandBar.vue?vue&type=script&lang=js"
export * from "./BrandBar.vue?vue&type=script&lang=js"

import "./BrandBar.vue?vue&type=style&index=0&id=8ccd0140&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__